import React from 'react'
import {
  PROMO_VARIABLE_NAMES,
  StyledFeatureVariable,
} from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { PROMO_FEATURE_FLAG, PROMO_I18N_NAMESPACE } from '../../lib/constants'

export const PromoCarryThroughText = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <StyledFeatureVariable
      flagName={PROMO_FEATURE_FLAG}
      variableName={PROMO_VARIABLE_NAMES.quizStickyFooterCopy}
      defaultCopy={t('quiz.footer.default')}
    />
  )
}
